export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/godaddy.b1ea4e9.svg";